import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name}
              className="h-16 w-auto mb-4 bg-white rounded-lg p-2"
            />
            <p className="text-slate-300 text-sm leading-relaxed">
              {companyInfo.tagline}. Delivering premium quality leaflets 
              and inserts with cutting-edge technology and unmatched expertise.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-slate-300 hover:text-blue-400 transition-colors text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-slate-300 hover:text-blue-400 transition-colors text-sm"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('strengths')}
                  className="text-slate-300 hover:text-blue-400 transition-colors text-sm"
                >
                  Our Strengths
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('infrastructure')}
                  className="text-slate-300 hover:text-blue-400 transition-colors text-sm"
                >
                  Infrastructure
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('quality')}
                  className="text-slate-300 hover:text-blue-400 transition-colors text-sm"
                >
                  Quality Management
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>Leaflet Printing</li>
              <li>Insert Manufacturing</li>
              <li>Custom Design Services</li>
              <li>Large Volume Orders</li>
              <li>Quick Turnaround</li>
              <li>Quality Assurance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="text-blue-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-slate-300 text-sm">{companyInfo.contact.address}</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="text-blue-400 flex-shrink-0" size={18} />
                <a 
                  href={`mailto:${companyInfo.contact.email}`}
                  className="text-slate-300 hover:text-blue-400 transition-colors text-sm break-all"
                >
                  {companyInfo.contact.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <div>
              © {currentYear} {companyInfo.name}. All rights reserved.
            </div>
            <div className="flex gap-6">
              <button className="hover:text-blue-400 transition-colors">Privacy Policy</button>
              <button className="hover:text-blue-400 transition-colors">Terms of Service</button>
              <button className="hover:text-blue-400 transition-colors">Sitemap</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
